export enum Authority {
	/*'ADMIN' = 4,
    'PROJECT_MANAGER' = 3,
    'PLANIFICATRICE' = 2,
    'INTERVENANT' = 1,*/
	DIRECTEUR_STRUCTURE = 20,
	RESPONSABLE_CENTRE = 30,
	PLANIFICATEUR = 40,
	CHARGE_MISSION = 50,
	INTERVENANT = 60
}
